import { render, staticRenderFns } from "./ModalUserHasNotPermission.vue?vue&type=template&id=faaa4262&scoped=true&"
import script from "./ModalUserHasNotPermission.vue?vue&type=script&lang=ts&"
export * from "./ModalUserHasNotPermission.vue?vue&type=script&lang=ts&"
import style0 from "./ModalUserHasNotPermission.vue?vue&type=style&index=0&id=faaa4262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faaa4262",
  null
  
)

export default component.exports